import './LabeledSelect.scss';

import { arrayOf, func, object, oneOfType, string, number } from 'prop-types';
import React from 'react';

import Option from 'components/shared/SelectOption/Option';

const LabeledSelect = ({
  dataTestId,
  ariaLabel,
  label,
  onChange,
  options,
  selection,
  placeholder = 'Select',
  disabled = false,
  name
}) => (
  <div className="select-group-label">
    <p className="select-label blocked_data">{label}</p>
    <select
      className="select-element blocked_data"
      data-testid={dataTestId}
      aria-label={ariaLabel}
      onChange={onChange}
      value={selection || ''}
      disabled={disabled}
      name={name}>
      <option key="default" value="" disabled defaultValue={''}>
        {placeholder}
      </option>
      {options.map((option, i) => (
        <Option key={i} option={option} />
      ))}
    </select>
  </div>
);

LabeledSelect.propTypes = {
  label: string,
  onChange: func,
  options: arrayOf(oneOfType([string, object])),
  selection: oneOfType([string, number])
};

export default LabeledSelect;
